module.exports = __webpack_public_path__ + "img/nut.41d23f4c.svg";